export const WORKFLOW_IDS = {
  UI_ACTIONS: "1d94d18f-e48a-410f-841c-a2b6d12be9db",
  ONSITE_INJECTIONS: "32ed3142-a47e-43b4-8283-9bfa04e49b49",
  GET_SELECTORS: "b8edc65b-a939-467e-9135-f5d419954a19",
  GET_SELECTOR: "5878710a-96bf-47e1-b9e7-26ee3a254eda",
  SITEWIDE_ANALYTICS_SUMMARY: "12e69d75-0c10-4272-aab9-be83bafbc1e9",
  MODIFICATIONS_CHAT: "8513b0b9-9b66-459b-8d85-fa42243bc861",
  SITEWIDE_ANALYTICS_SUMMARY_CHAT: "861d0951-6099-4739-8db7-bede0de0565e",
  CUSTOM_PROVIDER_CODE_CHAT: "bd5ac558-5058-4941-a003-ac3d41d63052",
  EXPERIENCE_CREATION_SINGLE_AGENT: "3c8ed743-4270-4489-891d-7d8bef5806b8",
  CONTENT_EXPERIENCE_INTAKE: "1b9fae5c-0b82-402a-8ac1-3212c1c6e139",
  AGENTIC_LOGIC_RULE_CREATION: "a77f7e85-df85-44f7-9172-c5ef55530ce6",
  AGENTIC_LOGIC_RULE_IDEAS: "ebee9010-07f1-4b98-86b8-4b1f132bd261",
};
